import React from "react";
import "./Clients.css";
import CheckIcon from "../assets/Icons/check.svg";
import ClientIcon from "../assets/Icons/client.svg";
import { useState } from "react";
import ClientModal from "./Modal/ClientModal";
import { Fragment } from "react";
import { useEffect } from "react";
import CrossIcon from "../assets/Icons/CrossIcon.svg";

const Clients = ({
  client,
  setClient,
  isError,
  isBtnDisable,
  isUpdate,
  dealStatus,
}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const [isClientAdded, setIsClientAdded] = useState(true);

  useEffect(() => {
    console.log("client", client);

    if (client !== null) {
      if (client?.name !== "" && client?.phone !== "") {
        setIsClientAdded(true);
      }
    } else {
      setIsClientAdded(false);
    }
  }, [client]);
  return (
    <Fragment>
      <div
        className={`add-deal-card client-card  ${
          isBtnDisable === true && "custom-disable-card"
        } ${isClientAdded ? "add-deal-card-filled" : ""}`}
        onClick={() => {
          if (isBtnDisable === false) {
            setModalStatus(true);
          }
        }}
      >
        {isClientAdded ? (
          <div className="active-status">
            <img src={CheckIcon} alt="landbook" />
          </div>
        ) : (
          isError && (
            <div className="active-status">
              <img src={CrossIcon} alt="landbook" />
            </div>
          )
        )}

        <div className="card-content">
          <img src={ClientIcon} alt="landbook" className="add-deal-card-icon" />
          <h2 className="add-deal-card-title">Client</h2>
          <p className="client-name">
            {client && client?.name !== "" ? client.name : "Select a client"}
          </p>
          <p className="client-contact">{client ? client.phone : "\n "}</p>
          <p className="client-gmail">{client ? client.email : "\n"}</p>
        </div>
      </div>

      <ClientModal
        {...{
          modalStatus,
          setModalStatus,
          client,
          setClient,
          isUpdate,
          dealStatus,
        }}
      />
    </Fragment>
  );
};

export default Clients;
